import { CodeHighlightNode, CodeNode } from '@lexical/code'
import { HorizontalRuleNode } from '@lexical/extension'
import { AutoLinkNode, LinkNode } from '@lexical/link'
import { ListItemNode, ListNode } from '@lexical/list'
import { InitialConfigType } from '@lexical/react/LexicalComposer'
import { HistoryPlugin } from '@lexical/react/LexicalHistoryPlugin'
import { LinkPlugin } from '@lexical/react/LexicalLinkPlugin'
import { ListPlugin } from '@lexical/react/LexicalListPlugin'
import { MarkdownShortcutPlugin } from '@lexical/react/LexicalMarkdownShortcutPlugin'
import { RichTextPlugin } from '@lexical/react/LexicalRichTextPlugin'
import { TabIndentationPlugin } from '@lexical/react/LexicalTabIndentationPlugin'
import { HeadingNode, QuoteNode } from '@lexical/rich-text'
import { TableCellNode, TableNode, TableRowNode } from '@lexical/table'
import { Klass, LexicalNode } from 'lexical'

import { lexicalTheme } from './theme'

/**
 * Base Lexical nodes for rich text editing
 */
export const baseNodes: Array<Klass<LexicalNode>> = [
  HeadingNode,
  ListNode,
  ListItemNode,
  QuoteNode,
  CodeNode,
  CodeHighlightNode,
  TableNode,
  TableCellNode,
  TableRowNode,
  LinkNode,
  AutoLinkNode,
  HorizontalRuleNode,
]

/**
 * Base configuration for Lexical editor
 */
export const createBaseConfig = (
  placeholder?: string,
  readOnly = false
): InitialConfigType => ({
  namespace: 'GeckoRichTextEditor',
  theme: lexicalTheme,
  onError: (error: Error) => {
    console.error('Lexical Editor Error:', error)
  },
  nodes: baseNodes,
  editable: !readOnly,
})

/**
 * Base plugins that should be included in all editor instances
 */
export const BasePlugins = [
  HistoryPlugin,
  RichTextPlugin,
  ListPlugin,
  LinkPlugin,
  MarkdownShortcutPlugin,
  TabIndentationPlugin,
]
